const currentGraduationYear = (() => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const nextYear =
    today.getMonth() >= 7 ? currentYear + 1 : currentYear; // next year on and after 1st of August
  return nextYear;
})();

export { currentGraduationYear };
